import { getRolesFromJWT } from './getRolesFromJWT';

const AW_ANONYMOUS_USER = 1000;

export function isGuestUser(jwt: string) {
  return getRolesFromJWT(jwt).includes(AW_ANONYMOUS_USER);
}
